import axios from 'axios'

import { normalize } from 'normalizr';
import { suspensionSchema } from '../../schemas';

import * as types from './types';

/* Fetch User Competition Leaderboards */

const fetchTournamentSuspensionsRequest = (tournament) => ({ type: types.FETCH_TOURNAMENT_SUSPENSIONS_REQUEST, tournament });
const fetchTournamentSuspensionsSuccess = (tournament, payload) => ({ type: types.FETCH_TOURNAMENT_SUSPENSIONS_SUCCESS, tournament, payload });
const fetchTournamentSuspensionsFailure = (tournament) => ({ type: types.FETCH_TOURNAMENT_SUSPENSIONS_FAIL, tournament });

const fetchTournamentSuspensions = (tournament) => (dispatch) => { 
    dispatch(fetchTournamentSuspensionsRequest(tournament));

    return axios.get(`/tournaments/${ tournament }/suspensions`).then(response => {
        
        dispatch(fetchTournamentSuspensionsSuccess(tournament, normalize(response.data, [suspensionSchema])));
    }, e => {
        
        dispatch(fetchTournamentSuspensionsFailure(tournament));
    });
}

const shouldFetchTournamentSuspensions = (state, tournament) => {
    const { isFetching, didInvalidate, items } = state.suspension.byTournament[tournament] || { isFetching : false, didInvalidate : false, items : null };

    if (isFetching) {
        return false;
    }
    else if (!items) {
        return true;
    }
    else {
        return didInvalidate;
    }
}

export const fetchTournamentSuspensionsIfNeeded = (tournament) => (dispatch, getState) => {
    if (shouldFetchTournamentSuspensions(getState(), tournament)) {
        dispatch(fetchTournamentSuspensions(tournament));
    }
}